module.exports = __webpack_public_path__ + "img/full4-min.4f63b4df.png";